<div class="backdrop">
    <ng-scrollbar class="remove-overflow-on-tablet modal">
      <div class="email-notif-settings-wrapper">
        <button type="button" id="btnClose" class="close-modal-btn" (click)="close.emit()">
          <svg class="close-modal-icon">
            <use spriteVersion iconName="modal-close"></use>
          </svg>
        </button>

        <div class="email-notif-settings-inner-wrapper">
          <p class="form-modal-title">Email Notifications</p>

          <ul class="email-notif-switcher-list">
            <!-- ALL toggles -->
            <li class="email-notif-switcher-item">
              <app-email-notification-toggle
                [value]="settings.all.toggled"
                [label]="'Notifications of all modules'"
                (toggle)="toggleSetting(['all'])">
              </app-email-notification-toggle>
            </li>

            <!-- Main toggles -->
            <li class="email-notif-switcher-item"
                *ngFor="let item of mainSettings" [ngClass]="{'email-notif-switcher-item__subToggles': item.isGroup}"
                [ngStyle]="{display: item.checkVisibility && settings.all.innerToggles[item.key]?.visible === false ? 'none': 'flex'}">
              <!-- Task group toggles -->
                <ng-container *ngIf="item.isGroup; else singleToggle">
                  <ng-container *ngIf="item.key === 'elementComments'; else taskNotifications">
                    <app-elements-email-notification-settings
                      [value]="settings.all.innerToggles.elementComments.toggled"
                      (toggleSetting)="toggleSetting($event)">
                    </app-elements-email-notification-settings>
                  </ng-container>

                  <ng-template #taskNotifications>
                    <div class="email-notif-switcher-item-inner-wrapper">
                      <app-email-notification-toggle
                        [value]="settings.all.innerToggles[item.key].toggled"
                        [label]="item.label"
                        (toggle)="toggleSetting(['all', item.key])">
                      </app-email-notification-toggle>
                    </div>

                    <!-- SubToggles -->
                    <ul class="notif--sub-switcher-list">
                      <li class="notif--sub-switcher-list__item" *ngFor="let sub of taskSubSettings">
                        <app-email-notification-toggle
                          [value]="settings.all.innerToggles[item.key].innerToggles[sub.key].toggled"
                          [label]="sub.label"
                          [description]="sub.description"
                          (toggle)="toggleSetting(['all', item.key, sub.key])">
                        </app-email-notification-toggle>

                        <!-- Reminder dropdown -->
                        <app-simple-selector
                          *ngIf="sub.key === 'taskReminder'"
                          [optionsMap]="taskReminderMap"
                          [selectedOption]="notificationSettings.taskReminderPeriod"
                          (changeEl)="notificationSettings.taskReminderPeriod = $event">
                        </app-simple-selector>
                      </li>
                    </ul>
                  </ng-template>
                </ng-container>

                <!-- Single toggle -->
                <ng-template #singleToggle>
                  <ng-container *ngIf="settings.all.innerToggles[item.key]?.visible !== false">
                    <app-email-notification-toggle
                      [value]="settings.all.innerToggles[item.key].toggled"
                      [label]="item.label"
                      [description]="item.description"
                      (toggle)="toggleSetting(['all', item.key])">
                    </app-email-notification-toggle>
                  </ng-container>
                </ng-template>
            </li>
          </ul>

        </div>

        <div class="form-btn-wrapper">
          <button type="button" class="btn-cancel" id="btnCancel" (click)="close.emit()">Cancel</button>
          <button type="submit" loader="white" [disabled]="submitBtnDisabled" [showLoader]="submitBtnDisabled" (click)="submit()" class="btn-invite" id="btnSave">Save</button>
        </div>
      </div>
    </ng-scrollbar>
</div>
